import { useIsEmeaCountry } from './useIsEmeaCountry';

/** `isLeftLeadEnabled` is provisional until `loading` clears. */
export const useIsLeftLeadEnabledOnOffering = (
  countryCode: string
): Readonly<{ isLeftLeadEnabled: boolean; loading: boolean }> => {
  const { isEmea, loading } = useIsEmeaCountry(countryCode);

  return { isLeftLeadEnabled: !isEmea, loading };
};
